module.exports = __webpack_public_path__ + "img/succeed.a3202a1a.jpg";